import { render, staticRenderFns } from "./fundDetail.vue?vue&type=template&id=60c588ce"
import script from "./fundDetail.vue?vue&type=script&lang=js"
export * from "./fundDetail.vue?vue&type=script&lang=js"
import style0 from "./fundDetail.vue?vue&type=style&index=0&id=60c588ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports